export {getContrastingColor, areAllTagsPresent, getAllQueryParams, getDeletionText, copyContentToClipboard};

//https://stackoverflow.com/a/41491220
function getContrastingColor(bgColor) {
    var color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    var uicolors = [r / 255, g / 255, b / 255];
    var c = uicolors.map((col) => {
        if (col <= 0.03928) {
        return col / 12.92;
        }
        return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = (0.2126 * c[0]) + (0.7152 * c[1]) + (0.0722 * c[2]);
    return (L > 0.179) ? 'black' : 'white';
}

function areAllTagsPresent(requiredTags, allTags, source) {
    let difference = requiredTags.filter(x => !allTags.includes(x + ''));
    if (difference.length > 0) {
        console.warn('Expected tags not present, ' + source + ': ' + difference);
        return false;
    }
    return true;
}

function getAllQueryParams() {
    let allQueryParams = '';
    new URLSearchParams(window.location.search).forEach((value, key) => {
        allQueryParams += "{" + key + " : " + value + "}\n";
    });
    return allQueryParams;
}

function getDeletionText(element) {
    let prefix = 'Delete ' + element + '. ';
    let suffixes = [
        "Sayonara, sucker!",
        "Gone with the wind.",
        "Buh-bye texty.",
        "Let's make it disappear.",
        "Delete and forget.",
        "Be gone, memory!",
        "Time to say goodbye.",
        "Off with its head.",
        "Erasing history.",
        "Farewell, old friend.",
        "Extinguish the flame.",
        "Terminate and annihilate.",
        "Disappear into oblivion.",
        "Banish to the abyss.",
        "Vanish without a trace.",
        "Adios, muchacho.",
        "Hasta la vista, baby.",
        "Hello darkness my old friend.",
        "See you never.",
        "Make it like it never existed.",
        "Wipe it off the face of the earth."
      ]
      return prefix + getRandomEntry(suffixes);
}

function getRandomEntry(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}



function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        changeCopyButtonText(true);
    } catch (err) {
        changeCopyButtonText(false);
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
}

async function copyContentToClipboard(msgContent) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(msgContent);
        return;
    }
    
    try {
        await navigator.clipboard.writeText(msgContent);
    } catch (err) {
        console.error('Failed to copy: ', err);
        return false;
    }
    return true;
}